import { asyncRouterMap, unconfirmedRouterMap, driverRouterMap, supervisorRouterMap, constantRouterMap } from '@/router'

/**
 * meta role
 * @param roles
 * @param route
 */
function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.indexOf(role) >= 0
  } else {
    return true
  }
}
function hasLocation(location, route) {
    // console.log("location", location)
    // console.log("route.meta", route.meta)
  if (route.meta && route.meta.location) {
    return route.meta.location.indexOf(location) >= 0
  } else {
    return true
  }
}
function hasCompany(company, route) {
  if (route.meta && route.meta.company) {
    if (company) {
      return true
    }
    return false
  } else {
    return true
  }
}

/**
 * filter
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, role, location, company) {
  const accessedRouters = asyncRouterMap.filter(route => {
    // console.log("location", location)
    if (hasPermission(role, route) && hasLocation(location, route) && hasCompany(company, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, role, location)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  getters: {
    permission_routers: state => state.routers,
    addRouters: state => state.addRouters
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    RESET_ROUTERS: (state) => {
      state.addRouters = []
      state.routers = constantRouterMap
    }
  },
  actions: {
    GenerateRoutes({ commit }, { role, confirmed, awakRole, userData }) {
      return new Promise(resolve => {
        let accessedRouters
        switch (role) {
          case 'dsrmanager': {
            accessedRouters = filterAsyncRouter(asyncRouterMap, role)
            break
          }
          case 'generalmanager': {
            accessedRouters = filterAsyncRouter(asyncRouterMap, role)
            break
          }
          default: {
            switch (awakRole) {
              case 'supervisor': {
                // console.log('supervisor', userData.location)
                accessedRouters = filterAsyncRouter(supervisorRouterMap, role, userData.location)
                break
              }
              case 'driver': {
                accessedRouters = filterAsyncRouter(driverRouterMap, role)
                break
              }
              default: {
                accessedRouters = filterAsyncRouter(unconfirmedRouterMap, role)
                break
              }
            }
            break
          }
        }
        // if (role === 'siriusmanager' || role === 'generalmanager' || userData.status === 'Paid') {
        //   if (awakRole === 'installer' && userData.company) {
        //     accessedRouters = filterAsyncRouter(asyncRouterMap, role, userData.company.company)
        //   } else {
        //     accessedRouters = filterAsyncRouter(asyncRouterMap, role)
        //   }
        // } else {
        //   switch (userData.status) {
        //     case 'Approved':
        //       accessedRouters = filterAsyncRouter(approvedRouterMap, role)
        //       break
        //     case 'Rejected':
        //       accessedRouters = filterAsyncRouter(rejectedRouterMap, role)
        //       break
        //     default:
        //       accessedRouters = filterAsyncRouter(unconfirmedRouterMap, role)
        //       break
        //   }
        // }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    ResetRoutes({ commit }) {
      return new Promise(resolve => {
        commit('RESET_ROUTERS')
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js